<!-- Plein écran : QR seul sur fond blanc, pour le scan à l'entrée -->
<div class="qr-fullscreen" *ngIf="fullscreen && selectedSocio" (click)="toggleFullscreen()">
  <qrcode [qrdata]="qrData" [width]="qrWidth" [errorCorrectionLevel]="'M'"
          [colorDark]="'#000000'" [colorLight]="'#ffffff'"></qrcode>
  <div class="qr-fullscreen__name">{{ formatName(selectedSocio.prenom) }} {{ formatName(selectedSocio.nom) }}</div>
  <div class="qr-fullscreen__hint">Touchez l'écran pour revenir</div>
</div>

<div class="socio-card-dialog" *ngIf="!fullscreen">
  <!-- Sélecteur de socio si plusieurs -->
  <div class="socio-selector" *ngIf="data.socios.length > 1">
    <button *ngFor="let socio of data.socios"
            mat-stroked-button
            [class.selected]="selectedSocio?.id === socio.id"
            (click)="selectSocio(socio)">
      {{ formatName(socio.prenom) }}
    </button>
  </div>

  <ng-container *ngIf="selectedSocio">
    <!-- Pass vertical façon Wallet : identité en haut, QR code en bas -->
    <div class="pass" [ngClass]="'pass--' + variant">
      <div class="pass__blocks pass__blocks--edge" aria-hidden="true"></div>
      <div class="pass__head">
        <!-- Saison de la dernière adhésion, en grand et en creux : se voit de loin à l'entrée -->
        <span class="pass__watermark" *ngIf="seasonShort" [attr.data-season]="seasonShort" aria-hidden="true">{{ seasonShort }}</span>

        <div class="pass__top">
          <span class="pass__patch"><img src="assets/logos/logo-sociochaux@3x-150x134.png" alt="" class="pass__logo"></span>
          <span class="pass__brand">MySociochaux</span>
        </div>

        <div class="pass__name">{{ formatName(selectedSocio.prenom) }}<br><strong>{{ formatName(selectedSocio.nom) }}</strong></div>
        <div class="pass__meta">
          <ng-container *ngIf="isSocio">Socio <span class="pass__number">n° {{ selectedSocio.techId }}</span></ng-container>
          <ng-container *ngIf="!isSocio">Membre</ng-container>
          <ng-container *ngIf="memberSince"> · depuis {{ memberSince }}</ng-container>
        </div>

        <div class="pass__tags">
        <!-- Statut affiché une fois l'adhésion chargée, pour ne pas afficher un faux « non adhérent » -->
        <div class="pass__status" *ngIf="pass"
             [ngClass]="{ 'is-ok': isAdherent && !expiresSoon, 'is-soon': expiresSoon, 'is-expired': adhesion && !isAdherent, 'is-none': !adhesion }">
          <span class="dot"></span>
          <ng-container *ngIf="isAdherent && !expiresSoon">Adhérent · jusqu'au {{ endDate | date:'dd/MM/yyyy' }}</ng-container>
          <ng-container *ngIf="expiresSoon">Adhésion : expire dans {{ daysLeft }} jour{{ daysLeft === 1 ? '' : 's' }}</ng-container>
          <ng-container *ngIf="adhesion && !isAdherent">Adhésion expirée le {{ endDate | date:'dd/MM/yyyy' }}</ng-container>
          <ng-container *ngIf="!adhesion">Non adhérent</ng-container>
        </div>
          <span class="pass__season" *ngIf="isAdherent && adhesion">{{ adhesion.campaign }}</span>
        </div>
      </div>

      <!-- Blocs de couleurs de l'écharpe 2026-27 -->
      <div class="pass__blocks" aria-hidden="true"></div>

      <!-- Étiquette tissée de l'écharpe : le QR code y est cousu -->
      <button type="button" class="pass__qr" (click)="toggleFullscreen()" aria-label="Afficher le QR code en plein écran">
        <qrcode [qrdata]="qrData" [width]="qrWidth" [errorCorrectionLevel]="'M'"
                [colorDark]="'#002d62'" [colorLight]="'#ffffff'"></qrcode>
        <span class="pass__hint"><mat-icon>fullscreen</mat-icon> Agrandir pour le scan</span>
      </button>
    </div>

    <p class="thanks" *ngIf="isSocio || isAdherent">Merci de faire vivre l'asso ! 💛💙</p>

    <a *ngIf="renewal" mat-flat-button color="primary" class="renew-btn"
       [routerLink]="['/c', renewal.slug]" (click)="close()">
      <mat-icon>autorenew</mat-icon> {{ isAdherent ? 'Renouveler' : 'Réadhérer' }}
    </a>
  </ng-container>

  <button mat-button class="close-btn" (click)="close()">Fermer</button>
</div>
